import { CHART } from './chart';

// One Nivo theme for every chart in the app — so a Nivo line, area, stream, bump,
// scatter, bar or heatmap all share the same axes, gridlines, tooltip and type.
// Import this + CHART.palette everywhere; never re-declare a per-chart theme.
//
// NOTE: the axis/grid colors are INLINED (not read from CHART) on purpose. Reading
// `CHART.*` while building this const at module-init is a cross-chunk temporal-dead-zone
// hazard — if a code-split chunk evaluates nivoTheme before chart.ts's `CHART` const
// initializes, you get "Cannot access 'R' before initialization" and a white screen.
// Keep these two values in sync with CHART.axisText / CHART.grid in chart.ts.
const AXIS_TEXT = '#8a94a6';                       // = CHART.axisText
const GRID_LINE = 'rgba(140,140,140,0.16)';        // = CHART.grid
export const nivoTheme = {
  background: 'transparent',
  text: { fill: AXIS_TEXT, fontFamily: 'inherit', fontSize: 11 },
  axis: {
    ticks: { text: { fill: AXIS_TEXT, fontSize: 11 }, line: { stroke: 'transparent' } },
    domain: { line: { stroke: GRID_LINE } },
  },
  grid: { line: { stroke: GRID_LINE } },
  crosshair: { line: { stroke: '#cfe0ff', strokeWidth: 1.5, strokeOpacity: 0.7, strokeDasharray: '' } },
  tooltip: {
    container: {
      background: '#161a24', color: '#dde', fontSize: 12, borderRadius: 8,
      border: '1px solid rgba(74,158,255,0.35)', padding: '8px 11px', boxShadow: '0 8px 28px rgba(0,0,0,0.4)',
    },
  },
} as const;

// Vertical gradient <defs> for area/stream/bar fills — one per palette slot (+ other),
// referenced by id `grad0`..`gradN`. `top`/`bottom` are the opacity stops.
export function gradientDefs(top = 0.55, bottom = 0.06) {
  return [...CHART.palette, CHART.other].map((color, i) => ({
    id: `grad${i}`,
    type: 'linearGradient' as const,
    x1: 0, y1: 0, x2: 0, y2: 1,
    colors: [
      { offset: 0, color, opacity: top },
      { offset: 100, color, opacity: bottom },
    ],
  }));
}
